<div class="edit-modal-search-container" *ngIf="show" [formGroup]="moresSearchProfile">
  <div class="loader-container" *ngIf="loader">
    <lib-loading></lib-loading>
  </div>
  <div class="inner-container" *ngIf="!loader">
    
    <div class="edit-header">
      <p class="edit-title">Perfil de busca</p>
      <lib-svg (click)="closed()" class="lib-svg" [icon]="'close_x_ico'"></lib-svg>
    </div>

    <div class="dropdown-box">
      <app-select
        labelText="Tipo de negócio"
        height="100%"
        [textTitle]="moresSearchProfile.get('business_type').value ? moresSearchProfile.get('business_type').value : ''"
        field="name"
        sizeList="5"
        [disabled]="!listLocation.length"
        [listItems]="listLocation"
        (sendTextSearch)="updateDropdownValue('business_type', $event.name, 'business_type')"
        (sendSearch)="moresSearchProfile.get('business_type').setValue($event.name)"
        (clearDropDown)="moresSearchProfile.get('business_type').setValue(null)">
      </app-select>
    </div>
    
    <div class="multi-selection">
      <lib-multi-selection [title]="'Quantidade de dormitórios'" [options]="roomQnt" (optionsToggled)="clickMultiToggle($event, 'bedrooms')"></lib-multi-selection>
    </div>
    
    <div class="multi-selection">
      <lib-multi-selection [title]="'Quantidade de suítes'" [options]="suitesQnt" (optionsToggled)="clickMultiToggle($event, 'suites')"></lib-multi-selection>
    </div>
  
    <div class="multi-selection">
      <lib-multi-selection [title]="'Quantidade de vagas'" [options]="parkingQnt" (optionsToggled)="clickMultiToggle($event, 'garage_spaces')"></lib-multi-selection>
    </div>
    
    <div class="inputs-container">
      <div class="multi-input-box" [ngClass]="{error: showError.cash}">
        <div class="input-box">
          <p class="box-title">Valor mínimo</p>
          <div class="currency-input">
            <span class="currency-prefix">R$</span>
            <input 
            type="text"
            mask="separator.0" 
            thousandSeparator="."
            formControlName="min_cash_value"
            >
          </div>
        </div>
    
        <div class="input-box">
          <p class="box-title">Valor máximo</p>
          <div class="currency-input">
            <span class="currency-prefix">R$</span>
            <input 
              type="text"
              mask="separator.0" 
              thousandSeparator="."
              formControlName="max_cash_value"
             >
          </div>
        </div>
      </div>
      <div class="error-msg" *ngIf="showError.cash">
        <lib-svg class="error-icon" [icon]="'error_alert_ico'"></lib-svg>
        <span class="error-description">O máximo não pode ser menor que o mínimo</span>
      </div>
    </div>
    
    <div class="inputs-container">
      <div class="multi-input-box" [ngClass]="{error: showError.area}">
        <div class="input-box">
          <p class="box-title">Área mínima</p>
          <div class="currency-input">
            <span class="currency-prefix">m²</span>
            <input 
              type="text"
              mask="separator.0" 
              thousandSeparator="."         
              minlength="0" 
              maxlength="11"              
              formControlName="min_area_value">
          </div>
        </div>
    
        <div class="input-box">
          <p class="box-title">Área máxima</p>
          <div class="currency-input">
            <span class="currency-prefix">m²</span>
            <input 
            type="text"
            mask="separator.0" 
            thousandSeparator="."     
            minlength="0" 
            maxlength="11"              
            formControlName="max_area_value">
          </div>
        </div>
      </div>
      <div class="error-msg" *ngIf="showError.area">
        <lib-svg class="error-icon" [icon]="'error_alert_ico'"></lib-svg>
        <span class="error-description">O máximo não pode ser menor que o mínimo</span>
      </div>
    </div>    
    
    <div class="dropdown-box">
      <app-select
        labelText="Tipo de imóvel"
        height="250"
        field=""
        sizeList="5"
        [textTitle]="moresSearchProfile.get('property_type').value ? moresSearchProfile.get('property_type').value : ''"
        [disabled]="!listProductType.length"
        [listItems]="listProductType"
        (sendSearch)="updateDropdownValue('property_type', $event, 'property_type')"
        (clearDropDown)="clearProperty()">
      </app-select>
    </div>

    <div class="dropdown-box">
      <app-select
        labelText="Estado"
        height="250"
        field="name"
        sizeList="5"
        [textTitle]="moresSearchProfile.get('state').value ? moresSearchProfile.get('state').value : ''"
        [disabled]="listState.length <= 0"
        [listItems]="listState"
        (sendSearch)="updateDropdownValue($event.type, $event.name, 'state'); getListCity($event.id)"
        (clearDropDown)="clearCityAndNeighborhoods()">
      </app-select>
    </div>

    <div class="dropdown-box">
      <app-select
        labelText="Cidade"
        height="250"
        field="name"
        sizeList="5"
        [textTitle]="moresSearchProfile.get('city').value ? moresSearchProfile.get('city').value : ''"
        [disabled]="listCity.length <= 0"
        [listItems]="listCity"
        (sendSearch)="updateDropdownValue('city', $event.name, 'city'); getNeighborhoods($event.id)"
        (clearDropDown)="clearSearchProduct('neighborhood_or_value_zone')">
      </app-select>
    </div>

    <div class="dropdown-box">
      <app-select
        labelText="Bairro / Zona de valor"
        height="200"
        field="name"
        sizeList="5"
        [textTitle]="moresSearchProfile.get('neighborhood_or_value_zone').value ? moresSearchProfile.get('neighborhood_or_value_zone').value.value : ''"
        [disabled]="listNeighborhoods.length <= 0"
        [listItems]="listNeighborhoods"
        [textOptions]="{
          field: 'type',
          equal: 'neighborhood',
          default: 'Zona de Valor',
          alternative: 'Bairro'
        }"
        (sendSearch)="updateDropdownValue('neighborhood_or_value_zone', {type: $event.type, value: $event.name}, 'neighborhood_or_value_zone')">
      </app-select>
    </div>
  
    <div class="dropdown-box">
      <p class="box-title">Comentários</p>
      <div class="comment-box">
        <textarea class="comment-textarea" formControlName="comments" maxlength="800"></textarea>
      </div>
    </div>

    <div class="btns-container">
      <lib-button-tertiary (click)="closed()">
        Cancelar
      </lib-button-tertiary>
      <lib-button-primary (click)="saveModal()" [isDisabled]="invalid">
        Salvar
      </lib-button-primary>
    </div>

  </div>
</div>
